import { post, get, upload } from '../../config/$ajax.js'
import { getErpHost } from '@/utils/domainHelper.js';

const API_HOST = getErpHost();

export const getAjax = (url, data = {}, params = {}) => {
  return get(API_HOST + url, data, params);
};

export const postAjax = (url, data = {}, params = {}) => {
  return post(API_HOST + url, data, params);
};


// 开关开启后重新获取库存信息  
// - 接口: `/item/stock/querySupplierStock.json`
// - 参数:
//     - baseItemId: 商品ID
//     - skuIds: skuId列表
export const querySupplierStock = function(data) {
  return post('/item/stock/querySupplierStock', data, {appJson: true, submitType: 'json'})
}

// 1. SKU库存详情
// - 接口: `/item/stock/list.json`
// - 参数:
//     - distributorCompanyId: 分销商公司ID
//     - supplierCompanyId: 供销商公司ID
//     - baseItemId: 基础商品ID
//     - isSupplierData: false
export const queryItemStockList = function(data) {
  return post('/item/stock/list', data, {appJson: true, submitType: 'json'})
}

// 2. 获取库存上传记录
// - 接口: `/item/stock/logList.json`
// - 参数:
//     - companyId: 公司ID
//     - sysItemId: ERP SPU ID
//     - sysSkuId: ERP SKU ID
//     - pageNo
//     - pageSize
export const queryStockLogList = function(data) {
  return post('/item/stock/logList', data, {appJson: true, submitType: 'json'})
}

// 2. 整款启用库存同步  
// - 接口: `/item/stock/batchOpenItemAutoSyncSupplierStock.json`
// - 参数: 
//     - baseItemIds: 商品ID
//     - isOpen: 开关状态
export const batchOpenItemAutoSyncSupplierStock = function(data) {
  return post('/item/stock/batchOpenItemAutoSyncSupplierStock', data, {appJson: true, submitType: 'json'})
}


// ##### c. 操作：款/单个SKU是否同步供销商库存
// 单个SKU启用库存同步  
// - 接口: `/item/stock/openSkuAutoSyncSupplierStock.json`
// - 参数:
//     - baseItemId: 商品ID
//     - skuId: skuId
export const openSkuAutoSyncSupplierStock = function(data) {
  return post('/item/stock/openSkuAutoSyncSupplierStock', data, {appJson: true, submitType: 'json'})
}

// ##### d. 批量改库存同步开关
// 1. 改库存同步前置校验
// - 接口: `/item/stock/checkStockStateList.json`
// - 参数: 
//     - companyId: 公司ID
//     - itemIdList: 商品ID列表
export const checkStockStateList = function(data) {
  return post('/item/stock/checkStockStateList', data, {appJson: true, submitType: 'json'})
}

// ### 4.4. 平台资料>填充ERP库存取值调整
// - 接口: `item/stock/queryStockList.json`
// - 参数: 
//     - baseItemId: 商品ID
export const itemStockQueryStockList = function(data) {
  return get('/item/stock/queryStockList', data)
}
export const queryItemSkuSalesPrice = function(data) {
  return post('/itemPrice/queryItemSkuSalesPrice', data,  {appJson: true, submitType: 'json'})
}

// 规格排序
export const autoImportErpItems = function(data, params) {
  return get('/item/source/autoImportErpItems', data, {isNeedFailNotice: params?.isNeedFailNotice || true})
}




// 规格排序
export const sortSpecifications = function(data) {
  return post('/shop/sortSpecifications', data, {appJson: true, submitType: 'json'})
}

// 获取erp商品库存
export const queryStockList = function(data) {
  return post('/item/base/queryStockList', data, {appJson: true, submitType: 'json'})
}

// 匹配ERP系统资料
export const queryErpItems = function(data) {
  return post('/item/base/queryErpItems', data, {appJson: true, submitType: 'json', isNeedLoading: false})
}

// 校验系统资料重复编码
export const checkOuterIdRepeat = function(data) {
  return post('/item/base/checkOuterIdRepeat', data, {appJson: true, submitType: 'json', isNeedLoading: true})
}

// 重复清理：查询重复编码分组列表
// 注意：实际后端路径请按YApi文档(ID: 140930)调整
// 这里先以占位路径实现，采用统一json提交格式
// 入参建议：{ pageNo, pageSize, keyword, sourceType }
// 返回：{ list: Group[], total: number }
export const queryDuplicateGroupList = function(data = {}) {
  return post('/repeat/item/detail/page', data, { appJson: true, submitType: 'json', isNeedLoading: true })
}

// 重复清理：批量合并平台资料
// 入参：{ repeatId: string | number, baseItemIds: string[] }
// 说明：后端合并策略为保留平台资料最多的商品，删除其他商品
export const mergeDuplicateItems = function(data = {}) {
  return post('/repeat/item/merge', data, { appJson: true, submitType: 'json', isNeedLoading: true })
}

export const deleteRepeatItems = function(data = {}) {
  return post('/repeat/item/delete', data, { appJson: true, submitType: 'json', isNeedLoading: true })
}

// 重复清理：获取所有重复记录的 ID 和 baseItemIds（不返回完整详情）
// 入参：{ startTime, endTime }
// 返回：[{ id: number, baseItemIds: string[] }]
export const getRepeatItemIds = function(data = {}) {
  return get('/repeat/item/ids', data, { isNeedLoading: true })
}

// 平台资料：查询平台资料上限与当前数量
// - 接口: `/repeat/item/platformLimitAndCount`
// - 入参: 无
// - 返回: { platformItemLimit: number | null, baseItemCount?: number }
export const queryPlatformLimitAndCount = function() {
  return get('/repeat/item/platformLimitAndCount', {}, { isNeedLoading: true })
}

// 判断加入分销商品款式编码是否已经存在
export const checkDistributionOuterId = function(data) {
  return post('/dim/checkDistributionOuterId', data, {appJson: true, submitType: 'json', isNeedLoading: true})
}

// 异步获取分销价和库存
export const getPriceAndStock = function(data) {
  return post('/dms/queryDisPriceAndStock', data, {appJson: true, submitType: 'json', isNeedLoading: true})
}


// 汉字转拼音接口
export const pinyin = function (data) {
  return post('/common/pinyin', data, { appJson: true, submitType: 'json' })
}

// 同步店铺品牌
export const submitBrandTask = (data = {}) => {
  return get('/brand/base/submitBrandTask', data);
}
// 查看店铺品牌同步进度
export const querySubmitBrandResult = (data = {}) => {
  return post('/brand/base/querySubmitBrandResult', {
      ...data,
      taskTypeEnum: 'SYNC_BRAND'
  }, {isNeedLoading: false})
}

// 获取店铺授权失效信息
export const getWarning = function() {
  return get('/user/notice/warn', {}, {isNeedLoading: true})
}

// 搜索类目信息
export const queryCategoryList = (data = {},params = {submitType: 'json'}) => {
  return post('/category/base/queryCategoryList', data, params)
}

// 同步平台资料
export const syncPlatformItem = (data = {}, params = {submitType: 'json', isNeedLoading: true}) => {
  return post('/item/base/syncPlatformItem', data, params)
}
// 批量同步平台资料
export const batchSyncPlatformItem = (data = {}, params = {submitType: 'json', isNeedLoading: true}) => {
  return post('/item/base/batchSyncPlatformItem', data, params)
}

// 批量商品同步，比较数据差异
export const checkSyncItems = (data = {}, params = {submitType: 'json',isNeedLoading: true}) => {
  return post('/item/base/checkSyncItems', data, params)
}

// 批量商品同步，比较市场价数据差异
export const checkSyncMarketItems = (data = {}, params = {submitType: 'json',isNeedLoading: true}) => {
  return post('/item/base/checkSyncMarketItems', data, params)
}

// 提交批量商品同步任务
export const submitSyncItemTask = (data = {}, params = {submitType: 'json',isNeedLoading: true}) => {
  return post('/item/base/submitSyncItemTask', data, params)
}

/**
 * 组合铺货，根据baseItemIds 获取多个商品基础详情
 */

 export const detailByBaseItemIds = (data = {},params = {submitType: 'json'}) => {
  return post('/item/base/detailByBaseItemIds', data, params)
}

/**
 * 铺货时获取分销商品详情
 */

export const distributorDetail = (data = {}, params = {submitType: 'json'}) => {
  return post('/item/distributor/detail', data, params)
}

// 添加供销商
export const supplierAdd = (data = {}) => {
  return post('/cg/supplier/add', data, {submitType: 'json', isNeedLoading: true})
}

// 采购供销商列表
export const cgSupplierList = (data = {}) => {
  return get('/cg/supplier/list', data, {isNeedLoading: true})
}

// 关联素材空间素材包接口
export const baseItemLinkFolder = (data = {}) => {
  return post('/item/base/baseItemLinkFolder', data, { submitType: 'json',})
}

// 解除关联素材空间素材包接口
export const baseItemCancelLinkFolder = (data = {}) => {
  return post('/item/base/baseItemCancelLinkFolder', data, { submitType: 'json',})
}
export const shareDamUrlPath = (data = {}) => {
  return postAjax('/index/auth/shareUrlPath', data)
}


/****** 快手平台相关 开始 *******/
// 查看快手平台资料详情
export const kuaishouDetail = function (data) {
  return get('/kuaishou/detail', data, { isNeedLoading: false })
}
// 查看快手平台资料详情(供销商小店版)
export const kuaishouDetailSupplier = function (data) {
  return get('/kuaishou/detailItem', data, { isNeedLoading: false })
}
// 查询类目属性
export const kuaishouCategoryProps = function (data) {
  return get('/kuaishou/getCategoryProperties', data, { isNeedLoading: true })
}
// 查询类目属性
export const kuaishouPropsValues = function (data) {
  return get('/kuaishou/getCategoryPropValue', data, { isNeedLoading: false })
}
// 编辑快手平台资料
export const kuaishouDetailEdit = function (data) {
  return post('/kuaishou/edit', data, { appJson: true, submitType: 'json' })
}
export const kuaishouDetailEdit2 = function (data) {
  return post('/shop/goods/kuaishou/editItem', data, { appJson: true, submitType: 'json' })
}
// 查询商品销售属性填写规则
export const kuaishouSalePropRule = function (data) {
  return get('/kuaishou/getSalePropRule', data)
}

// 批量修改快手类目
export const kuaishouBatchUpdateCategory = function (data) {
  return post('/kuaishou/batchUpdateCategory', data, { appJson: true, submitType: 'json' })
}
export const KSConfirmPriceStock = function({data}) {
  return post('/kuaishou/batchPublish/confirmPriceStock', data, {isNeedLoading: false, submitType: 'json'})
}
export const batchApplyBrandToShops = function({data}) {
  return post('/kuaishou/batchPublish/batchApplyBrandToShops', data, {appJson: true,isNeedLoading: true, submitType: 'json'})
}

// 保存商品视频
export const editKuaishouCarouselVideo = function(data) {
  return post('/kuaishou/edit/carouselVideo', data, { appJson: true, submitType: 'json', isNeedLoading: false })
}

/****** 快手平台相关 结束 *******/

/****** 1688平台相关 开始 *******/
// 1688获取商品发布规则信息
export const AlibabaForm = (data) => {
  return get('/alibaba/getItemPublishSchema', data, { isNeedLoading: false })
}
export const getAlibabaItemPublishSubSchema = (data) => {
  return post('/alibaba/getItemPublishSubSchema', data, { isNeedLoading: false })
}
export const getAlibabaAsyncQueryInfo = (data) => {
  return get('/alibaba/asyncQueryInfoGetInfo', data, { isNeedLoading: false })
}
export const getAlibabaFreightTemplates = (data) => {
  return get('/alibaba/getTemplateList', data, { isNeedLoading: false })
}
// 查看1688平台资料详情
export const alibabaDetail = function (data) {
  return get('/alibaba/detail', data, { isNeedLoading: false })
}
// 查看1688平台资料详情(供销商小店版)
export const alibabaDetailSupplier = function (data) {
  return get('/alibaba/detailItem', data, { isNeedLoading: false })
}
// 查询类目属性
export const alibabaCategoryProps = function (data) {
  return get('/alibaba/getCategoryProperties', data, { isNeedLoading: true })
}
// 编辑1688平台资料
export const alibabaDetailEdit = function (data) {
  return post('/alibaba/edit', data, { appJson: true, submitType: 'json' })
}
export const alibabaDetailEdit2 = function (data) {
  return post('/shop/goods/1688/editItem', data, { appJson: true, submitType: 'json' })
}
// 批量修改1688类目
export const alibabaBatchUpdateCategory = function (data) {
  return post('/alibaba/batchUpdateCategory', data, { appJson: true, submitType: 'json' })
}
// 获取阿里巴巴运费模板
export const getAlibabaTemplateList = (data = {}) => {
  return get('/alibaba/getTemplateList', data, { isNeedLoading: false });
}
// 获取阿里巴巴发货地址
export const getAlibabaShippingAddress = (data = {}) => {
  return get('/alibaba/getShippingAddress', data, { isNeedLoading: false });
}
// 判断当前公司是否展示按钮 入参 无
export const isShowOffsiteOfferBtn = (data = {}) => {
  return get('/alibaba/isShowOffsiteOfferBtn', data, { isNeedLoading: false });
}

// 转为站外货源商品
export const alibabaTranformOffsiteOffer = (data = {}) => {
  return post('/alibaba/getOffsiteOffer', data, { appJson: true, submitType: 'json'});
}
// 获取发货地址列表
export const alibabaGetShippingAddress = (data = {}) => {
  return get('/alibaba/getShippingAddress', data, { isNeedLoading: false });
}



/****** 1688平台相关 结束 *******/

/****** 京东平台相关 开始 *******/
// 查看京东平台资料详情
export const jdDetail = function(data) {
  return get('/jd/detail', data, {isNeedLoading: false})
}
// 查看京东平台资料详情(供销商小店版)
export const jdDetailSupplier = function(data) {
  return get('/jd/detailItem', data, {isNeedLoading: false})
}
// 查询类目属性
export const jdCategoryProps = function(data) {
  return get('/jd/getCategoryProperties', data, {isNeedLoading: true})
}
export const getSaleAttrs = function(data) {
  return get('/jd/getSaleAttrs', data, {isNeedLoading: true})
}
export const getProductSchemas = function(data) {
  return get('/jd/getProductSchemas', data, { isNeedLoading: true })
}
// 获取京东类目规则模板组件（食品安全等）
export const listCategoryRuleTemplatesComponents = function(data) {
  return get('/jd/listCategoryRuleTemplatesComponents', data, { appJson: true, submitType: 'json' })
}
// 编辑京东平台资料
export const jdDetailEdit = function(data) {
  return post('/jd/edit', data, { appJson: true, submitType: 'json'})
}
export const jdDetailEdit2 = function(data) {
  return post('/shop/goods/jd/editItem', data, { appJson: true, submitType: 'json'})
}
// 批量修改京东类目
export const jdBatchUpdateCategory = function(data) {
  return post('/jd/batchUpdateCategory', data, {appJson: true, submitType: 'json'})
}
// 获取京东商品产地列表
export const jdWareLocationList = function() {
  return get('/jd/getWareLocationList', {}, {isNeedLoading: false})
}
// 获取京东品牌列表
export const jdVenderBrandList = function(data) {
  return post('/jd/getVenderBrandList', data, {appJson: true, submitType: 'json'})
}
// 京东上传图片
export const jdUpload = function(data) {
  return upload('/jd/uploadSinglePicture', data, {isNeedLoading: false})
}
// 京东查询类目信息【获取当前类目是否有品牌校验】
export const jdFindCategoryInfo = function(data) {
  return get('/jd/findCategoryInfo', data)
}
export const isShowLengthWidthHeight = function(data) {
  return get('/jd/isShowLengthWidthHeight', data)
}

// 京东查询不需要回显展示的品牌列表
export const jdFindNontShowBrandIds = function() {
  return get('/jd/findNontShowBrandIds', {}, {isNeedLoading: false})
}
// 获取京东品牌列表（单个店铺获取）
export const jdVenderBrandListByshopId = function(data) {
  return get('/jd/getVenderBrandByShopIdAndCategoryId', data, {isNeedLoading: false})
}

// 查询发货时效
export const jdSellerDeliverySendPromiseTemplate = function(data) {
  return get('/jd/getSellerDeliverySendPromiseTemplate', data, {isNeedLoading: false})
}

// 获取类目的推荐图规则
export const jdGetCategoryFeature = (data) => {
  return get('/jd/getCategoryFeature', data, {isNeedLoading: false})
}
// 批量修改标题
export const jdBatchUpdateItemName = function({data}) {
  return post('/jd/batchUpdateItemName', data, {appJson: true,isNeedLoading: true, submitType: 'json'})
}
// 批量更新库存
export const jdBatchUpdateStock = function({data}) {
  return post('/jd/batchUpdateStock', data, {appJson: true,isNeedLoading: true, submitType: 'json'})
}

/****** 京东平台相关 结束 *******/


/****** 京东秒送平台相关 开始 *******/
//获取详情
export const jdmsDetail = function(data) {
  return get('/jdms/detail', data, {isNeedLoading: false})
}
//获取可用的商品属性
export const jdmsCategoryProps = function(data) {
  return get('/jdms/getCategoryProperties', data, {isNeedLoading: true})
}
//获取销售规则
export const jdmsSalePropRule = function(data) {
  return get('/jdms/getSalePropRule', data, {isNeedLoading: true})
}
// 编辑京东平台资料
export const jdmsDetailEdit = function(data) {
  return post('/jdms/edit', data, { appJson: true, submitType: 'json'})
}
// 获取店铺分类
export const jdmsShopCategory = function(data) {
  return get('/jdms/getShopCategory', data, {isNeedLoading: true})
}
// 根据类目和指定code，查询特殊的商品属性，是否展示，是否启用
export const jdmsSpecCategoryProps = function(data) {
  return get('/jdms/getSpecCategoryProps', data, {isNeedLoading: true})
}
// 根据类目和指定code，查询退货标签特殊属性
export const jdmsSpecCategoryPropsValue = function(data) {
  return get('/jdms/getSpecCategoryPropsValue', data, {isNeedLoading: true})
}
// 查询退货标签特殊属性
export const jdmsReturnSpecCategoryPropsValue = function(data) {
  return get('/jdms/getReturnSpecCategoryPropsValue', data, {isNeedLoading: true})
}
export const jdmsBrandList = function(data) {
  return get('/jdms/getBrandList', data, {isNeedLoading: true})
}
/****** 京东秒送平台相关 结束 *******/

/****** 微信视频号平台相关 开始 *******/
// 查看微信视频号平台资料详情
export const wxhDetail = function(data) {
  return get('/wxsph/detail', data, {isNeedLoading: false})
}
// 编辑微信视频号平台资料
export const wxhDetailEdit = function(data) {
  return post('/wxsph/edit', data, { appJson: true, submitType: 'json'})
}
export const wxhDetailEdit2 = function(data) {
  return post('/shop/goods/wxsph/editItem', data, { appJson: true, submitType: 'json'})
}
// 获取微信视频号运费模板
export const getWxhTemplateList = (data = {}) => {
  return get('/wxsph/getTemplateList', data, { isNeedLoading: false });
}

// 获取微信视频号退货地址
export const getWxhAddressList = (data = {}) => {
  return get('/wxsph/getAddressList', data, { isNeedLoading: false });
}
// 获取微信视频号运费模板
export const getWxhCategoryProperties = (data = {}) => {
  return get('/wxsph/getCategoryProperties', data, { isNeedLoading: true });
}
// 批量修改微信视频号类目
export const wxhBatchUpdateCategory = function (data) {
  return post('/wxsph/batchUpdateCategory', data, { appJson: true, submitType: 'json' })
}
export const getWxhBrandValidList = (data = {}) => {
  return get('/wxsph/getBrandValidList', data, { isNeedLoading: false });
}
export const queryWxsphBatchProductList = function({data}) {
  return post('/wxsph/queryBatchProductList',data, {isNeedLoading: false, submitType: 'json'})
}
export const wxhBatchUpdate = function(data) {
  return post('/wxsph/batchUpdate',data, {isNeedLoading: true, submitType: 'json'})
}
export const wxsphBatchUpdateSku = function(data) {
  return post('/wxsph/batchUpdateSku',data, {isNeedLoading: true, submitType: 'json'})
}
// 编辑微信视频号轮播视频
export const editWxhCarouselVideo = function(data = {}) {
  return post('/wxsph/edit/carouselVideo', data, { isNeedLoading: false, appJson: true, submitType: 'json' })
}

/****** 微信视频号平台相关 结束 *******/

/****** 闲鱼平台相关 开始 *******/
// 查看闲鱼资料详情
export const xianyuDetail = function(data) {
  return get('/xianyu/detail', data, {isNeedLoading: false})
}
// 编辑闲鱼平台资料
export const xianyuDetailEdit = function(data) {
  return post('/xianyu/edit', data, { appJson: true, submitType: 'json'})
}
// 查询闲鱼商品属性
export const getXianyuProductAttribute = (data = {}) => {
  return get('/xianyu/getProductAttribute', data, { isNeedFailNotice: true });
}
// 闲鱼地区获取
export const getXianyuRegion = (data = {}) => {
  return get('/xianyu/getRegion', data, { isNeedLoading: false });
}

/****** 闲鱼平台相关 结束 *******/

/****** 快团团平台相关 开始 *******/
// 查看快团团资料详情
export const kttDetail = function(data) {
  return get('/ktt/detail', data, {isNeedLoading: false})
}
// 编辑快团团平台资料
export const kttEdit = function(data) {
  return post('/ktt/edit', data, { appJson: true, submitType: 'json'})
}
/****** 快团团平台相关 结束 *******/

/****** 微店平台相关 开始 *******/
export const wdDetail = function(data) {
  return get('/weidian/detail', data, {isNeedLoading: false})
}
// 编辑微信视频号平台资料
export const wdDetailEdit = function(data) {
  return post('/weidian/edit', data, { appJson: true, submitType: 'json'})
}
/****** 微店平台相关 结束 *******/

// 查看平台类目
export const getPlatformCategoryTree = function (data, platform) {
  let platformApiNames = {
    'tjb': 'taote',
    'yyjk': 'fyy',
    'xy': 'xianyu',
    '1688': 'alibaba',
  }
  const platformApiName = platformApiNames[platform] || platform
  return get(`/${platformApiName}/getCategoryTree`, data, { isNeedLoading: false })
}

// 查询公司可用基础类目
export const getCompanyCategory = function () {
  return get('/category/base/getCompanyCategory', {}, { isNeedLoading: false })
}
// 查询当前账号的所有子账号
export const getSubAccount = function () {
  return get('/account/getSubAccount', {}, { isNeedLoading: false })
}


// 查询公司可用基础类目
export const findgoodscategory = function () {
  return get('/companyBusinessInfo/showCooperationIntention/findgoodscategory', {}, { isNeedLoading: false })
}

// 查询已设置主营类目
export const getMainCategory = function () {
  return get('/category/base/getMainCategory', {})
}

// 设置主营类目
export const setMainCategory = function (data) {
  return post('/category/base/setMainCategory', data, { appJson: true, submitType: 'json' })
}

// 基础类目树查询
export const getCategoryTree = function (data) {
  return get('/category/base/getCategoryTree', data, { isNeedLoading: false })
}

// 基础商品列表
export const getItemBasePage = function (data) {
  return post('/item/base/page', data, { appJson: true, submitType: 'json' })
}
// 基础商品规格列表
export const getItemBaseSkuPage = function (data) {
  return post('/item/base/querySkuPage', data, { appJson: true, submitType: 'json' })
}
// 查询商品erp库存
export const getBaseItemErpStockList = function (data) {
  return post('/item/base/getBaseItemErpStockList', data, { appJson: true, submitType: 'json',isNeedLoading: false })
}
// 查询商品sku erp库存
export const getBaseItemSkuErpStockList = function (data) {
  return post('/item/base/getBaseItemSkuErpStockList', data, { appJson: true, submitType: 'json',isNeedLoading: false })
}
// 查询商品销量
export const getBaseItemOrderNumList = function (data) {
  return post('/item/base/getBaseItemOrderNumList', data, { appJson: true, submitType: 'json',isNeedLoading: false })
}
// 查询SKU销量
export const getBaseItemSkuOrderNumList = function (data) {
  return post('/item/base/getBaseItemSkuOrderNumList', data, { appJson: true, submitType: 'json',isNeedLoading: false })
}
// 商品备注
export const batchUpdateItemRemark = function (data) {
  return post('/item/base/batchUpdateItemRemark', data, { appJson: true, submitType: 'json' })
}

// 查询自动导入商品进度
export const queryInitItemLog = function (data) {
  return get('/logging/queryInitItemLog', data)
}

// 基础商品详情
export const getItemBaseDetail = function (data) {
  return get('/item/base/detail', data, { isNeedLoading: false })
}

// 基础商品详情编辑
export const editItemBaseDetail = function (data) {
  return post('/item/base/edit', data, { appJson: true, submitType: 'json' })
}
export const shopGoodsGetItemDetail = function (data, config = {}) {
  return post('/shop/goods/getItemDetail', data, { appJson: true, submitType: 'json', ...config })
}

/**
 * 批量修改重量
 * @param {*} data
 * @returns
 */
export const updateBatchweight = function (data) {
  return post('/item/base/batchUpdateWeight', data, { appJson: true, submitType: 'json' })
}

// 批量修改价格及库存按平台
export const updateBatchPriceOrStockForPlatform = function (data) {
  return post('/item/base/batchUpdateItem', data, { appJson: true, submitType: 'json' })
}
// 异步改造: 批量修改价格及库存 - 异步提交
export const updateBatchPriceOrStockForPlatformAsync = function (data) {
  return post('/item/base/batchUpdateItemAsync', data, { appJson: true, submitType: 'json', isNeedFailNotice: true })
}
// 异步改造: 查询批量修改任务进度
export const queryBatchUpdateItemResult = function (params) {
  return get('/item/base/queryBatchUpdateItemResult', params, { appJson: true, isNeedLoading: false })
}
// 批量修改商品名称
export const batchUpdateTitle = function (data) {
  return post('/item/base/batchUpdateTitle', data, { appJson: true, submitType: 'json' })
}
// 查询kmt_erp商品信息
export const queryKmtErpItem = function (data) {
  return get('/kmterp/item/searchKmtErpItem', data, { appJson: true, submitType: 'json' })
}
// 提交手动绑定kmt和erp商品任务
export const submitChangeKmtErpItem = function (data) {
  return post('/kmterp/item/submitChangeKmtErpItem', data, { appJson: true, submitType: 'json' })
}
// 查询kmt供分销商品数据
export const queryItemMatchFxReleation = function (data) {
  return get('/kmterp/item/itemMatchFxReleation', data, { appJson: true, submitType: 'json' })
}

// 查询kmt供分销商品数据（供销商）
export const supplierQueryItemMatchFxReleation = function (data) { 
  return post('/kmtfx/item/supplier/manage/itemMatchFxReleation', data, { appJson: true, submitType: 'json' })
}

// 自动绑定kmt 供分销商品
export const autoBindKmtItem = function (data) {
  return post('/kmterp/item/autoBindKmtFxItem', data, { appJson: true, submitType: 'json' })
}
// 手动绑定kmt 供分销商品
export const manualBindKmtItem = function (data) {
  return post('/kmterp/item/bindKmtFxItem', data, { appJson: true, submitType: 'json' })
}
// 提交读取对应表关系建立快麦通商品和ERP商品的关联关系任务
export const platformItemReleation = function (data) {
  return get('/kmterp/platformItem/platformItemReleation', data, { appJson: true, submitType: 'json' })
}
export const platformItemSkuReleation = function (data) {
  return post('/kmterp/platformItem/platformItemSkuReleation', data, { appJson: true, submitType: 'json' })
}

// 批量修改商品进度条
export const batchUpdateTitleProgress = function (data) {
  return post('/item/base/batchUpdateTitleProgress', data, { appJson: true, submitType: 'json' })
}


// 批量修改分销/私密状态
export const updateBatchState = function (data) {
  return post('/item/base/batchUpdateStateAsync', data, { appJson: true, submitType: 'json' })
}

// 批量设置可见状态
export const batchUpdatePrivacy = function (data) {
  return post('/distribution/shop/opt/batchUpdatePrivacy', data, { appJson: true, submitType: 'json' })
}

// 查询批量修改分销/私密状态结果
export const getBatchUpdateStateResult = function (data) {
  return get('/item/base/getBatchUpdateStateResult', data, { appJson: true, submitType: 'json' })
}

// 批量提报货源
export const putBatch = function (data) {
  return post('/distribution/shop/item/chaeck', data, { appJson: true, submitType: 'json' })
}

// // 快捷创建分销商品规则 按款
// export const batchBindDistributor = function (data) {
//   return post('/scm/auth/batch/item', data, { appJson: true, submitType: 'json' })
// }

// // 快捷创建分销商品规则 按款
// export const batchBindDistributorBySku = function (data) {
//   return post('/scm/auth/batch/sku', data, { appJson: true, submitType: 'json' })
// }
// 前置查询校验接口
export const queryErpSkuOuterId = function (data) {
  return post('/item/base/queryErpSkuOuterId', data, { appJson: true, submitType: 'json' })
}

// 下载未绑定的erp商品
export const downLoadUnboundErpItems = function (data) {
  return get('/item/base/downLoadUnboundErpItems', data);
}

// 批量删除商品
export const delBatch = function (data) {
  return post('/item/base/batchDelete', data, { appJson: true, submitType: 'json' })
}

// 基础商品批量修改类目
export const updateBatchCategory = function (data) {
  return post('/item/base/batchUpdateCategory', data, { appJson: true, submitType: 'json' })
}

// 商品上架
export const publishItems = function (data) {
  return post('/item/base/publishItem', data, { isNeedLoading: false, appJson: true, submitType: 'json' })
}
// 商品上架查询进度
export const publishItemsResult = function (data, url = '/item/platform/queryPublishSpeed') {
  return get(url, data, { isNeedLoading: false })
}

// 查询分销规则结果
export const distributionRuleResult = function (data) {
  return post('/item/base/queryPublishItemResult', data, { isNeedLoading: false })
}

// erp商品列表查询接口
export const getListErpItem = async function (params) {
  const { data = {} } = await post('/item/base/listErpItem', params, { appJson: true, submitType: 'json' })
  return data
}
// erp导入商品接口 /item/source/importErpItems.json
export const importErpItems = async function (params) {
  const res = await post('/item/source/importErpItems', params, { appJson: true, submitType: 'json', isNeedLoading: false })
  return res
}
export const importErpItemsByStyle = async function (params) {
  const res = await post('/item/source/importErpSpuItems', params, { appJson: true, submitType: 'json', isNeedLoading: false })
  return res
};
// 平台商品下载/erp商品导入结果查询
// export const getQueryScmJobResult = async function (params) {
//   params = Object.assign({ taskTypeEnum: 'IMPORT_ERP_ITEM' }, params)
//   const res = await post('/item/source/queryScmJobResult.json', params, { isNeedLoading: false })
//   return res
// }

// 获取平台商品列表
export const getShopOfProduct = function (data) {
  return post('/item/source/page', data, { appJson: true, submitType: 'json' })
}

// 同步商品
export const syncShopTask = function (data) {
  return post('/shopTask/submitSyncItemTask', data, { appJson: true, submitType: 'json' })
}

// 同步商品
export const querySubmitSyncSelectedItemTask = function (data) {
  return get('/shopTask/querySubmitSyncSelectedItemTask', data, { appJson: true, submitType: 'json' })
}

export const getSyncProgress = function (data) {
  return get('/shopTask/syncProgress', data, { appJson: true, submitType: 'json' })
}
export const cancelSync = function (data) {
  return post(`/shopTask/cancelSync`,data, { submitType: 'json',queryInUrl:true })
}


// 从平台获取最新商品
export const sourceSearchList = function (data) {
  return post('/item/source/searchList', data, { appJson: true, submitType: 'json' })
}

// 依据outerId获取scm中商品数据，用于校验spu是否重复
export const checkScmItemByIds = function (data) {
  // let extraParams = isDownload ? {download: true} : {}
  return post('/item/base/checkScmItem', data, { appJson: true, submitType: 'json' })
}

// 校验编辑基础商品款式编码是否重复
export const checkSameOuterId = function (id, config) { 
  return post('/item/base/checkEdit', {outerId: id}, { appJson: true, submitType: 'json', isNeedLoading: false, ...config })
}

// 平台商品下载
export const downloadShopProduct = function (data) {
  return post('/item/source/downloadItems', data, { appJson: true, submitType: 'json' })
}
// 平台商品下载 新 -上面为旧版本废弃接口
export const downloadShopProductNew = function (data) {
  return post('/item/source/downloadItemsTask', data, { appJson: true, submitType: 'json' })
}

// 终止下载任务
export const stopTask = function (data) {
  return get('/item/source/stopTask', data)
}

// 平台商品下载结果查询
export const queryScmJobResult = function (data, queries) {
  let url = '/item/source/queryScmJobResult'
  if (queries) {
    let queryParams = Object.keys(queries).map(key => {
      return `${key}=${queries[key]}`;
    });
    url = `${url}?${queryParams.join('&')}`;
  }
  return post(url, data, { isNeedLoading: false, submitType: 'json' })
}

// 平台商品下载结果查询 -新
export const queryTaskSpeed = function (data,queries) {
  let url = '/item/source/queryTaskSpeed'
  return get(url, data, { isNeedLoading: false })
}

// 查询手动绑定kmt商品 erp商品 任务结果
export const queryScmJobResult_KMT_ERP = function (data) {
  return post('/item/source/queryScmJobResult?taskTypeEnum=CHANGE_KMT_ERP_ITEM', data, { isNeedLoading: false, submitType: 'json' })
}
export const queryScmJobResult_KMT_ERP2 = function (taskTypeEnum) {
  return post('/item/source/queryScmJobResult?taskTypeEnum='+taskTypeEnum, {}, { isNeedLoading: false, submitType: 'json' })
}
/****** 抖音平台相关 开始 *******/
// 获取抖音商品详情
export const queryFxgDetail = function (data) {
  return get('/fxg/detail', data, { isNeedLoading: false })
}
// 获取抖音商品详情（供销商小店版）
export const queryFxgDetailSupplier = function (data) {
  return get('/fxg/detailItem', data, { isNeedLoading: false })
}
// 获取抖音AI类目白名单问题修复
export const getScmCodeFxg = function (data) {
  return get('/user/getScmCode', data, { isNeedLoading: false })
}
// 抖音平台类目属性查询
export const queryFxgCategoryProperties = function (data) {
  return post('/fxg/getCategoryProperties', data, { isNeedLoading: true })
}
// 抖音平台资料编辑
export const editFxgDetail = function (data) {
  return post('/fxg/edit', data, { appJson: true, submitType: 'json' });
}
export const editFxgDetail2 = function (data) {
  return post('/shop/goods/fxg/editItem', data, { appJson: true, submitType: 'json' });
}
// 抖音平台资质查询
export const fxgSearchProductQualityList = function (data) {
  return get('/fxg/searchProductQualityList', data);
}
export const fxgSearchProductQualityList2 = function (data) {
  return post('/fxg/searchProductQualityListV2', data,{appJson:true,submitType: 'json'});
}
// 查询抖音类目是否支持商品前缀
export const queryFxgNeedProductNameFix = function (data) {
  return get('/fxg/needProductNameFix', data);
}
// 查询抖音类目下商品标题前缀
export const getFxgProductNameFix = function (data) {
  return post('/fxg/getProductNameFix', data, { appJson: true, submitType: 'json' });
}

// 校验商品标题
export const fxgPublishPreCheckTitle = function (data) {
  return post('/fxg/publishPreCheckTitle', data);
}

// 查询商品无理由退货服务规则
export const getProductUpdateRule = function (data) {
  return get('/fxg/getProductUpdateRule', data);
}

// 批量修改抖音类目
export const fxgBatchUpdateCategory = function (data) {
  return post('/fxg/batchUpdateCategory', data, { appJson: true, submitType: 'json' })
}
// 【抖音】获取品牌列表
export const fxgBrandList = function(data) {
  return get('/fxg/brandList', data, { isNeedLoading: false })
}
export const fxgBrandListV2 = function(data) {
  return get('/fxg/brandListV2', data, { isNeedLoading: false })
}
export const fxgRefreshBrand = function(data) {
  return get('/fxg/refreshBrand', data, { isNeedLoading: true })
}

// 获取各个平台的品牌列表
export const getBrandListV2PlatForm = function(data) {
  return get(`/${data.platform}/brandListV2`, data, { isNeedLoading: false })
}
export const getPlatFormBrandList = function(data, url) {
  return get(url, data, { isNeedLoading: false })
}
export const refreshPlatFormBrand = function(data, url) {
  return get(url, data, { isNeedLoading: true })
}

export const batchBrandFill = function(data, url) {
  return post(url || '/fxg/batchBrandFill', data, { submitType: 'json'})
}

// 【抖音】查询尺码模板列表
export const fxgSizeTemplateList = function(data) {
  return post('/fxg/querySizeTemplateList', data, {isNeedLoading: true, submitType: 'json'})
}
// 【抖音供销平台】查询尺码模板列表
export const fxgGxSizeTemplateList = function(data) {
  return post('/fxg_gx/querySizeTemplateList', data, {isNeedLoading: true, submitType: 'json'})
}

// 【抖音】更新或保存尺码模板
export const fxgAddOrUpdateSizeTemplate = function(data) {
  return post('/fxg/addOrUpdateSizeTemplate', data, {isNeedLoading: true, submitType: 'json'})
}
export const fxgSizeSort = function(data) {
  return post('/fxg/sizeSort', data, {isNeedLoading: false, submitType: 'json'})
}
export const fxgGenerateItemSizeInfo = function(data, platform) {
  let url = '/fxg/generateItemSizeInfo'
  if(platform === 'fxg_gx') {
    url = '/fxg_gx/generateItemSizeInfo'
  }
  return post(url, data, { submitType: 'json'})
}

// 【抖音】校验商品是否符合抖音的类目预测
export const fxgRecommendCatStatus = function(data) {
  return post('/fxg/recommend/cat/status', data, {isNeedLoading: true, submitType: 'json'})
}
// 【抖音】保存批量铺货临时配置
export const saveBatchTempConf = function({data,platform}) {
  return post(`/${platform || 'fxg'}/saveBatchTempConf`, data, {isNeedLoading: true, submitType: 'json'})
}
// 【抖音】获取批量铺货商品详情信息
export const queryBatchDetail = function({data,platform}) {
  return post(`/${platform || 'fxg'}/queryBatchDetail`, data, {isNeedLoading: false, submitType: 'json'})
}

// 【抖音】获取批量铺货
export const batchPublishItem = function({data,platform}) {
  return post(`/${platform || 'fxg'}/batchPublishItem`, data, {isNeedLoading: true, submitType: 'json'})
}
// 保存批量铺货临时价格
export const saveBatchTempPrice = function({data,platform}) {
  return post(`/${platform || 'fxg'}/saveBatchTempPrice`, data, {isNeedLoading: true, submitType: 'json'})
}
// 拼多多获取按sku配置预售时间详情页接口
export const pddGetSkuList = function(data) {
  return get(`/pdd/getSkuList`, data, { isNeedLoading: false })
}

/**
 * 获取级联属性值
 * @param {*} params 参数
 * @returns
 */
export const fxgGetCategoryPropertyValue = (params) => {
  return get('/fxg/getCategoryPropertyValue', params)
}
/**
 * 获取级联属性值
 * @param {*} params 参数
 * @returns
 */
export const fxgGetCascadeValues = (params) => {
  return post('/fxg/getCascadeValue', params, {isNeedLoading: true, submitType: 'json'})
}
/**
 * 抖音SKU改造，获取平铺格式的导航值
 * @returns
 */
export const fxgGetParallelCascadeValues = (params) => {
  return post('/fxg/queryCascadeValue', params, {isNeedLoading: true, submitType: 'json'})
}

// 【抖音】校验公司是否在尺码校验灰度名单
export const inFxgSizeCheckWhiteList = (params) => {
  return get('/fxg/temp/isFxgSizeTempCheck', params).then(res => {
    return res.result == 1 ? res : Promise.reject(res);
  });
}

// 抖音铺货，查询后置校验铺货重要信息
export const queryFxgItemShopList = function(data) {
  return post('/fxg/queryFxgItemShopList', data, {isNeedLoading: true, submitType: 'json'})
}
// 抖音铺货，新增或更新后置校验铺货重要信息
export const addOrUpdateItemShop = function(data) {
  return post('/fxg/addOrUpdateItemShop', data, {isNeedLoading: true, submitType: 'json'})
}
export const checkFxgCategoryMisplaced = function(data) {
  return get('/fxg/productAlert/checkCategoryMisplaced', data, {isNeedLoading: false, isNeedFailNotice: true })
}
export const checkFxgAiSizeOptimization = function(data) {
  return get('/fxg/productAlert/checkAiSizeOptimization', data, {isNeedLoading: false, isNeedFailNotice: true })
}
/****** 抖音平台相关 结束 *******/
/**
 * 铺货前的二次确认
 * @param {*} params 参数
 * @returns 
 */
export const publishConfirmValid = (params) => {
  return post('/item/base/secConfirmationItem', params, {isNeedLoading: true, submitType: 'json'})
}

/**
 * 商品资料完善度二次确认V2
 * @param {*} params 参数
 * @returns 
 */
export const secConfirmationItemV2 = (params) => {
  return post('/item/base/secConfirmationItemV2', params, {isNeedLoading: true, submitType: 'json'})
}
// 判断用户所选择的平台店铺价格是否破价
export const preCheckControllerPrice = (params) => {
  return post('/ltsTask/preCheckControllerPrice', params, {isNeedLoading: false, submitType: 'json'})
}

export const detailPreCheckControllerPrice = (params) => {
  return post('/ltsTask/detailPreCheckControllerPrice', params, {isNeedLoading: false, submitType: 'json'})
}

// 获取通用平台以及店铺的sku对应价格
export const getControllerPriceList = (params) => {
  return post('/ltsTask/getControllerPriceList', params, {submitType: 'json'})
}
// 获取用户自定义计算规则对应的价格
export const getControllerPriceListByCustom = (params) => {
  return post('/ltsTask/getControllerPriceListByCustom', params, {submitType: 'json'})
}

/****** 拼多多平台相关 开始 *******/
// 获取拼多多外部绑定关系
export const queryPddRelationInfo = function(data) {
  return post('/pdd/getRelationInfo', data, {appJson: true, submitType: 'json'})
}

// 获取拼多多商品详情
export const queryPddDetail = function(data) {
  return get('/pdd/detail', data, {isNeedLoading: false})
}
export const queryPddDetailSupplier = function(data) {
  return get('/pdd/detailItem', data, {isNeedLoading: false})
}
// 拼多多平台类目属性查询
export const queryPddCategoryProperties = function(data, opts = {}) {
  return get('/pdd/getCategoryProperties', data, {isNeedLoading: true, ...opts})
}
// 获取品牌必填规则拼多多平台
export const getBrandRequireRule = function(data, opts = {}) {
  return get('/pdd/getBrandRequireRule', data, {isNeedLoading: false, ...opts})
}
// 模糊搜索查询品牌接口
export const queryPddCategoryPropertiesForKeywords = function(data) {
  return get('/pdd/searchPropertyValue', data, {isNeedLoading: false})
}

export const queryApplyBrandConfig = function(data, params) {
  return get('/dsb/applyBrandConfig', data, {isNeedLoading: false, ...params})
}
export const queryPddBrandList = function(data, params) {
  return get('/pdd/getBrandList', data, {isNeedLoading: false, ...params})
}
export const initPddBrandList = function(data, params) {
  return post('/pdd/initBrandList', data, {isNeedLoading: false, ...params})
}

// 拼多多平台资料编辑
export const editPddDetail = function(data) {
  return post('/pdd/edit', data, {appJson: true, submitType: 'json'});
}
export const editPddDetail2 = function(data) {
  return post('/shop/goods/pdd/editItem', data, {appJson: true, submitType: 'json'});
}
// 批量修改拼多多类目
export const pddBatchUpdateCategory = function(data) {
  return post('/pdd/batchUpdateCategory', data, {appJson: true, submitType: 'json'})
}
// 拼多多获取规格名列表
export const queryPddSpecList = function(data = {}) {
  return get('/pdd/getSpecList', data, {isNeedLoading: false})
}
export const getPddGroupSpecNames = function(data = {}) {
  return post('/pdd/getGroupSpecNames', data, {isNeedLoading: false})
}

// 拼多多获取地区/国家
export const queryPddCountryList = function(data = {}) {
  return get('/pdd/getCountrys', data, {isNeedLoading: false})
}
// 拼多多获取规格名id
export const queryPddSpecId = function(data = {}) {
  return post('/pdd/getSpecIdInfo', data, {isNeedLoading: false})
}
// 上传图片=
export const uploadPddFile = function(data = {}) {
  return post('/pdd/uploadImage', data, {isNeedLoading: false, appJson: true, submitType: 'json'})
}
// 上传图片到图片空间
export const uploadPddFileSpace = function(data = {}) {
  return post('/pdd/uploadFileSpace', data, {isNeedLoading: false})
}
// 上传拼多多轮播视频到店铺
export const carouselVideo = function(data = {}) {
  return post('/pdd/upload/carouselVideo', data, { appJson: true, submitType: 'json' })
}
// 编辑拼多多轮播视频
export const editPddCarouselVideo = function(data = {}) {
  return post('/pdd/edit/carouselVideo', data, { isNeedLoading: false, appJson: true, submitType: 'json' })
}

// 商品素材创建接口
export const createPddRaterialImage = function(data = {}) {
  return post('/pdd/createRaterialImage', data, {isNeedLoading: false})
}
// 商品素材删除接口
export const deletePddRaterialImage = function(data = {}) {
  return post('/pdd/deleteRaterialImage', data, {isNeedLoading: false})
}
// 商品素材删除接口
export const getPddRaterialImage = function(data = {}) {
  return get('/pdd/queryRaterialImage', data, {isNeedLoading: false})
}
// 类目属性品牌,搜索接口
export const getSearchPropertyValue = function(data = {}) {
  return get('/pdd/searchPropertyValue', data, {isNeedLoading: false})
}
// 获取拼多多视频上传详情
export const reqPddCarouselVideoInfo = (data = {}) => {
  return post('/pdd/getCarouselVideoInfo', data, { isNeedLoading: false, appJson: true, submitType: 'json' });
};
// 获取资料页详情的sku价格明细
export const getPlatformDetailSkuPrice = (data = {}) => {
  return post('/itemPrice/getPlatformDetailSkuPrice', data, { appJson: true, submitType: 'json' });
};
/****** 拼多多平台相关 结束 *******/


/****** Temu平台相关 开始 *******/
// 查看Temu资料详情
export const temuDetail = function(data) {
  return get('/pddtemu/detail', data)
}
// 查看Temu资料详情-半托管
export const temuBtgDetail = function(data) {
  return get('/pddtemu/btg/detail', data)
}
// 编辑Temu平台资料
export const temuEdit = function(data) {
  return post('/pddtemu/edit', data, { appJson: true, submitType: 'json'})
}
// 编辑Temu半托管平台资料
export const temuBtgEdit = function(data) {
  return post('/pddtemu/btg/edit', data, { appJson: true, submitType: 'json'})
}
// 查询Temu商品属性
export const getTemuProductAttribute = (data = {}) => {
  return get('/pddtemu/getGoodsAttrs', data);
}
// Temu品牌
export const getTemuBrandList = (data = {}) => {
  return get('/pddtemu/getBrandList', data);
}
export const getTemuParentSpec = (data = {}) => {
  return get('/pddtemu/getParentSpec', data, { isNeedLoading: false });
}
// 查询货品包装清单类型
export const getTemuGoodsAccessories = (data = {}) => {
  return get('/pddtemu/getGoodsAccessories', data, { isNeedLoading: false });
}
// 查询货品包装清单类型
export const getTemuSizechartsClass = (data = {}) => {
  return get('/pddtemu/getSizechartsClass', data, { isNeedLoading: false });
}
// 查询尺码表元信息
export const getTemuSizechartsMeta = (data = {}) => {
  return get('/pddtemu/getSizechartsMeta', data, { isNeedLoading: false, isNeedFailNotice: true });
}

// 查询尺码表模板列表
export const getTemuSizecharts = (data = {}) => {
  return get('/pddtemu/getSizecharts', data, { isNeedLoading: false });
}
// 查询尺码模板规则
export const getTemuSizechartsSettings = (data = {}) => {
  return get('/pddtemu/getSizechartsSettings', data, { isNeedLoading: false });
}
// 创建尺码模板
export const createTemuSizecharts = (data = {}) => {
  return post('/pddtemu/createSizecharts', data, {  appJson: true, submitType: 'json' });
}

// 上传轮播视频到店铺
export const uploadTemuCarouselVideo = function(data = {}) {
  return post('/pddtemu/upload/video', data, { appJson: true, submitType: 'json' })
}
// 编辑轮播视频
export const editTemuCarouselVideo = function(data = {}) {
  return post('/pddtemu/edit/video', data, { isNeedLoading: false, appJson: true, submitType: 'json' })
}
export const getTemuVideoInfo = function(data = {}) {
  return post('/pddtemu/getVideoInfo', data, { appJson: true, submitType: 'json'})
}
// 查询运费模版列表（全托管 / 半托管通用）
export const getTemuFreightTemp = function(data = {}) {
  return get('/pddtemu/freight-templates', data, {})
}
// 查询是否支持模特
export const getTemuModelCats = function(data = {}) {
  return get('/pddtemu/getModelCats', data, {})
}
// 查询模特数据
export const getTemuModelInfo = function(data = {}) {
  return get('/pddtemu/getModelInfo', data, {})
}
// 新增模特
export const addTemuModelInfo = function(data = {}) {
  return post('/pddtemu/addModelInfo?shopId='+data.shopId, data, { appJson: true, submitType: 'json'})
}
// 半托管 - 查询经营站点列表（仅已开站，支持按站点名称 / 站点ID 搜索）
export const getBtgSites = function(data = {}) {
  return get('/pddtemu/btg/sites', data, { })
}
// 半托管 - 查询发货仓列表
export const getBtgWarehouse = function(data = {}) {
  return get('/pddtemu/btg/warehouse', data, { })
}
// 半托管 - 多站点申报价查询
export const getBtgMultiSitePrice = function(data = {}) {
  return get('/pddtemu/btg/multi-site-price', data, { })
}
/****** Temu平台相关 结束 *******/



// 拼款铺货接口
export const groupOnShelf = function(data = {}) {
  let url = data.platform === 'fxg' ? '/item/platform/fxgPiecePublish' : '/item/platform/piecePublish';
  return post(url, data, {isNeedLoading: true, appJson: true, submitType: 'json'})
}
// 拼款铺货接口
export const getSkus = function(data = {}) {
  return post('/item/base/getSkuList', data, {isNeedLoading: true, appJson: true, submitType: 'json'})
}
export const queryPieceItemSkuList = function(data = {}) {
  return post('/item/base/queryPieceItemSkuList', data, {isNeedLoading: true, appJson: true, submitType: 'json'})
}

// 指定供销商的拼款铺货接口
export const getSupplierSkus = function(data = {}) {
  return post('/dms/getSupplierSkuList', data, {isNeedLoading: true, appJson: true, submitType: 'json'})
}

// 京东拼款铺货接口
export const getSkuListByJd = function(data = {}) {
  return post('/item/base/getSkuListByJd', data, {isNeedLoading: true, appJson: true, submitType: 'json'})
}

// 查询常用规格
export const queryCommonlySpecifications = function (data) {
  return get('/item/base/queryCommonlySpecifications', data)
}

// 编辑常用规格模板
export const editCommonlySpecifications = function (data) {
  return post('/item/base/editCommonlySpecifications', data, { appJson: true, submitType: 'json' })
}
// 删除常用规格模板
export const deleteCommonlySpecifications = function (data) {
  return get('/item/base/deleteCommonlySpecifications', data)
}

/****** 淘宝平台相关 开始 *******/
// 【淘宝】根据baseitemID获取商品详情
export const TBDetail = (data) => {
  return get('/tb/detailV2', data)
}

// 【淘宝】根据baseitemID获取商品详情(供销商小店版)
export const TBDetailSupplier = (data) => {
  return get('/tb/detailItem', data)
}

// 【淘宝】编辑淘宝商品
export const TBEdit = (data) => {
  return post('/tb/edit', data, { appJson: true, submitType: 'json' })
}
export const TBEdit2 = (data) => {
  return post('/shop/goods/tb/editItem', data, { appJson: true, submitType: 'json' })
}

//【淘宝】获取商品发布规则信息
export const TBForm = (data) => {
  return get('/tb/getItemPublishSchema', data, { isNeedLoading: false })
}

// 【淘宝】商品级联属性信息获取
export const getSchemaProp = (data) => {
  return get('/tb/getItemPublishSchemaProp', data)
}

// 【淘宝】 批量修改类目
export const tbBatchUpdateCategory = function(data) {
  return post('/tb/batchUpdateCategory', data, {appJson: true, submitType: 'json'})
}

// 【淘宝】 获取次级属性
export const tbGetSchemaProp = (data) => {
  return post('/tb/getItemPublishSchemaPropV2', data, {appJson: true, submitType: 'json', isNeedLoading: false})
}
// 尺码表映射
export const sizeMapping = (data) => {
  return post('/publish/fast/prediction/size/mapping', data, {appJson: true, submitType: 'json', isNeedLoading: false})
}
// 尺码表模版列表
export const sizeMappingList = (data) => {
  return get('/tb/size/mapping/list', data, {appJson: true, submitType: 'json', isNeedLoading: false})
}
// 尺码表模版保存
export const sizeMappingSave = (data) => {
  return post('/tb/size/mapping/save', data, {appJson: true, submitType: 'json', isNeedLoading: false})
}
// 尺码表模版修改
export const sizeMappingUpdate = (data) => {
  return post('/tb/size/mapping/update', data, {appJson: true, submitType: 'json', isNeedLoading: false})
}
// 尺码表模版删除
export const sizeMappingDelete = (data) => {
  return get('/tb/size/mapping/delete', data, {appJson: true, isNeedLoading: false})
}
export const tbConfirmPriceStock = function({data}) {
  return post('/tb/batchPublish/confirmPriceStock', data, {appJson: true,isNeedLoading: false, submitType: 'json'})
}
// 批量修改标题
export const batchUpdateItemName = function({data}) {
  return post('/tb/batchUpdateItemName', data, {appJson: true,isNeedLoading: true, submitType: 'json'})
}
// 批量更新库存
export const tbBatchUpdateStock = function({data}) {
  return post('/tb/batchUpdateStock', data, {appJson: true,isNeedLoading: true, submitType: 'json'})
}
export const tbBatchUpdateSkuPrice = function({data}) {
  return post('/tb/batchUpdateSkuPrice', data, {appJson: true,isNeedLoading: true, submitType: 'json'})
}
/****** 淘宝平台相关 结束 *******/

/****** 天猫平台相关 开始 *******/
// 【天猫】根据baseitemID获取商品详情
export const TMDetail = (data, config = {}) => {
  return get('/tm/detail', data, config)
}
// 【天猫】根据baseitemID, shopId, sourceShopId获取商品详情
export const TmDetailByOtherShop = (data, config = {}) => {
  return get('/tm/detailByOtherShop', data, config)
}
export const TMFastDetail = (data, config = {}) => {
  return get('/publish/fast/detail', data, config)
}
export const getTmProductSimpleConversion = (data) => {
  return get('/tm/getProductSimpleConversion', data, { isNeedLoading: false, isNeedFailNotice: true })
}
export const getTmDetailSimpleConversion = (data) => {
  return get('/tm/getDetailSimpleConversion', data, { isNeedLoading: false, isNeedFailNotice: true })
}

// 【天猫】根据baseitemID获取商品详情(供销商小店版)
export const TMDetailSupplier = (data) => {
  return get('/tm/detailItem', data)
}

// 【天猫】获取品牌
export const TMBrandList = (data) => {
  return get('/tm/getBrandList', data, { isNeedLoading: false })
}

// 【天猫】编辑天猫商品
export const TMEdit = (data, options = {}) => {
  return post('/tm/edit', data, {
      appJson: true,
      submitType: 'json',
      isNeedLoading: false,
      ...options
  })
}
export const TMEdit2 = (data) => {
  return post('/shop/goods/tm/editItem', data, {appJson: true, submitType: 'json', isNeedLoading: false})
}

//【天猫】获取匹配产品规则
export const TMProductForm = (data) => {
  return get('/tm/getProductMatchSchema', data, { isNeedLoading: false })
}

//【天猫】product匹配接口-铺货第一步的下一步按钮按下
export const matchProductSchema = (data) => {
  return post('/tm/matchProductSchema', data, { appJson: true, submitType: 'json', isNeedLoading: false })
}
export const getTmProductInfo = (data) => {
  return get('/tm/getProductInfo', data, { appJson: true, submitType: 'json', isNeedLoading: false })
}
//【天猫】创建product接口-铺货第二步的下一步按钮按下
export const addProductSchema = (data) => {
  return post('/tm/addProductSchema', data, { appJson: true, submitType: 'json', isNeedLoading: false })
}
//【天猫】产品发布规则获取接口-铺货第二步表单生成所需
export const getAddProductSchema = (data) => {
  return get('/tm/getAddProductSchema', data, { isNeedLoading: false })
}
//【天猫】商品发布规则获取接口-铺货第三步表单生成所需
export const getPublishSchema = (data, url, config = {}) => {
  return get(url || '/tm/getItemPublishSchema', data, config)
}
//【天猫】获取天猫运费模板列表
export const getTmallTemplateList = (data) => {
  return get('/tm/getTmallTemplateList', data, {isNeedLoading: false})
}
// 清除铺货
export const deleteCache = () => {
  return get('/test/deleteCache', {cacheKey:'PUBLISH_ITEM_26487'}, {isNeedLoading: false})
}
// 获取天猫店铺
export const getTmShopList = (data) => {
  return get('/tm/shop/list', data, {isNeedLoading: false})
}

/****** 天猫平台相关 结束 *******/

/**淘特平台相关  开始 */

//【淘特】根据 baseItemId 获取详情
export const TaoTeDetail = (data) => {
  return get('/taote/detail', data)
}

//【淘特】编辑淘特商品
export const TaoTeEdit = (data) => {
  return post('/taote/edit', data, { appJson: true, submitType: 'json' })
}

//【淘特】获取商品发布规则信息
export const TaoTeForm = (data) => {
  return get('/taote/getItemPublishSchema', data, { isNeedLoading: false })
}

// 【淘特】商品级联属性信息获取
export const getTaoTeSchemaProp = (data) => {
  return get('/taote/getItemPublishSchemaProp', data)
}
// 批量修改淘特类目
export const tjbBatchUpdateCategory = function (data) {
  return post('/taote/batchUpdateCategory', data, { appJson: true, submitType: 'json' })
}

/**淘特平台相关  结束 */


/********* 有赞平台相关  开始 **********/

//【有赞】根据 baseItemId 获取详情
export const YouZanDetail = (data) => {
  return get('/yz/detail', data)
}

//【有赞】编辑商品
export const YouZanEdit = (data) => {
  return post('/yz/edit', data, { appJson: true, submitType: 'json' })
}

//【有赞】查询类目属性
export const YouZanCategoryProps = function(data) {
  return get('/yz/getCategoryProperties', data, {isNeedLoading: true})
}

// 批量修改有赞类目
export const yzBatchUpdateCategory = function (data) {
  return post('/yz/batchUpdateCategory', data, { appJson: true, submitType: 'json' })
}
/******** 有赞平台相关  结束 ********/

/****** 微信小店平台相关 开始 *******/

// 【微信小店】平台资料详情(供销商小店版)
export const wxxdDetailSupplier = function (data) {
  return get('/wxxd/detailItem', data, { isNeedLoading: false })
}

//【微信小店】平台商品详情
export const WxxdDetail = (data) => {
  return get('/wxxd/detail', data)
}

//【微信小店】编辑商品
export const WxxdEdit = (data) => {
  return post('/wxxd/edit', data, { appJson: true, submitType: 'json' })
}

// 【微信小店】批量修改类目
export const wxxdBatchUpdateCategory = function(data) {
  return post('/wxxd/batchUpdateCategory', data, {appJson: true, submitType: 'json'})
}
/****** 微信小店平台相关 结束 *******/


/****** 小红书平台相关 开始 *******/

//【小红书】平台商品详情
export const XhsDetail = (data) => {
  return get('/xhs/detail', data)
}

// 【美团闪购】 平台商品详情
// export const MtsgDetail = (data) => {
//   return get('/Mtsg/detail', data)
// }
// 查询类目属性
export const queryXhsCategoryProperties = function (data) {
  return get('/xhs/getAttributeList', data, { isNeedLoading: true })
}
// 查询类目属性的值
export const queryXhsCategoryPropertiesValue = function (data) {
  return get('/xhs/getAttributeValues', data, { isNeedLoading: true })
}
// 批量修改类目
export const xhsBatchUpdateCategory = function (data) {
  return post('/xhs/batchUpdateCategory', data, { appJson: true, submitType: 'json' })
}
// 小红书编辑保存
export const editXhsDetail = function (data) {
  return post('/xhs/edit', data, { appJson: true, submitType: 'json' });
}
export const editXhsDetail2 = function (data) {
  return post('/shop/goods/xhs/editItem', data, { appJson: true, submitType: 'json' });
}
// 获取物流方案
export const getLogisticsList = function (data, config = {}) {
  return get('/xhs/getLogisticsList', data, { ...config });
}
export const getDeliveryRule = function (data, config = {}) {
  return get('/xhs/getDeliveryRule', data, { ...config });
}
export const getCarriageTemplateList = function (data, config = {}) {
  return get('/xhs/getCarriageTemplateList', data, { ...config });
}
// 获取品牌
export const getBrandList = function (data, config = {}) {
  return get('/xhs/brandSearch', data, { ...config });
}
// 获取小红书规格映射
export const mappingVariations = function (data) {
  return get('/xhs/detailByMappingVariations', data);
}
// 获取小红书规格列表
export const getVariations = function (data) {
  return get('/xhs/getVariations', data);
}
// 小红书规格重新获取
export const xhsSpecAutoMerge = function (data) {
  return get('/xhs/xhsSpecAutoMerge', data);
}
// 获取小红书某个规格id对应的规格值
export const getAttributeValues = function (data) {
  return get('/xhs/getAttributeValues', data);
}
// 编辑小红书视频接口
export const editXhsCarouselVideo = function(data = {}) {
  return post('/xhs/edit/carouselVideo', data, { isNeedLoading: false, appJson: true, submitType: 'json' })
}

/****** 小红书平台相关 结束 *******/


/****** shein平台相关 开始 *******/
export const SheinDetail = (data) => {
  return get('/shein/detail', data)
}
// 编辑保存
export const editSheinDetail = function (data) {
  return post('/shein/edit', data, { appJson: true, submitType: 'json' });
}
// 获取店铺对应的品牌
export const SheinBrandList = (data) => {
  return get('/shein/getBrandList', data)
}
 // 获取商品属性
export const sheinCategoryProps = function(data) {
  return get('/shein/getCategoryProperties', data, {isNeedLoading: true})
}
 // 查询是否支持自定义属性值
export const getCustomAttributeApi = function(data) {
  return post('/shein/getCustomAttributePermissionConfig', data, {isNeedLoading: true,submitType: 'json'})
}
 // 添加自定义属性
export const addCustomAttributeApi = function(data,shopId) {
  return post('/shein/goodsAddCustomAttributeValue?shopId='+shopId, data, {isNeedLoading: true,submitType: 'json'})
}
// 获取站点列表
export const getSheinSiteListApi = function(data) {
  return get('/shein/getSiteList', data, {isNeedLoading: true})
}
/****** shein平台相关 结束 *******/

/****** 套图相关接口 开始 *******/
// 获取商品套图
export const getGroupPictures = function (data) {
  return post('/item/picture/query', data, { isNeedLoading: false });
}
// 保存商品套图
export const saveItemGroupPicture = function (data) {
  return post('/item/picture/save', data, { appJson: true, submitType: 'json' });
}
// 删除商品套图
export const deleteItemGroupPicture = function (data) {
  return post('/item/picture/delete', data);
}

/****** 套图相关接口 结束 *******/

/****** 查看平台链接相关 开始 ******/
// 【查看平台链接】查询商品列表
export const getLinkSkuList = (data) => {
  return post('/item/link/querySkuList', data, { appJson: true, submitType: 'json' })
}
// 【查看平台链接】查询平台铺货列表
export const getLinkList = (data) => {
  return post('/item/link/queryList', data, { appJson: true, submitType: 'json' })
}
// 【查看平台链接】刷新店铺商品
export const getLinkSyncShopList = (data) => {
  return post('/item/link/syncShopList', data, { appJson: true, submitType: 'json' })
}
/****** 查看平台链接相关 结束 ******/
/** 批量下架  开始 */
export const getLinkSkuItemList = (data) => {
  return post('/item/link/queryItemList', data, { appJson: true, submitType: 'json' })
}
/**
 * 批量下架商品
 * @param {*} data 参数
 * @returns
 */
export const platformSkuOffSale = (data) => {
  return post('/item/platform/offSale', data, { appJson: true, submitType: 'json' })
}
/** 批量下架  结束 */
/** 批量更新铺货 开始 */
// 【更新平台资料】查询平台铺货列表
export const getEditItemLinkList = (params) => {
  return post('/item/base/getPlatformInfosV2', params,{ appJson: true, submitType: 'json' })
}
export const getPlatformInfosXsdList = (params) => {
  return get('/item/base/getPlatformInfosXsd', params)
}
// 小时达-- 门店列表查询
export const getXsdStoreList = (params) => {
  return post('/xsd/store/list', params, { appJson: true, submitType: 'json' })
}
// 小时达-- 门店列表同步
export const xsdStoreListSync = (params) => {
  return get('/xsd/store/list/sync', params)
}
// 小时达-- 查询门店商品
export const queryXsdStoreItemList = (params) => {
  return post('/xsd/store/xsdSyncItemList', params, { appJson: true, submitType: 'json' })
}
// 小时达-- 门店列表同步状态查询
export const xsdStoreListSyncDone = (params) => {
  return get('/xsd/store/list/sync/done', params, { isNeedLoading: false })
}
// 小时达-- 创建店铺商品同步到门店任务
export const xsdSyncItemToStoreTask = (params) => {
  return post('/xsd/store/syncItemToStoreTask', params, { appJson: true, submitType: 'json' })
}
// 小时达-- 创建店铺商品同步到门店--任务进度
export const xsdQueryTaskSpeed = (params) => {
  return get('/xsd/store/queryTaskSpeed', params, { isNeedLoading: false })
}
/**
 * 批量校验平台商品状态
 * @param {*} data 参数
 * @returns
 */
export const batchCheckItemState = (data) => {
  return post('/item/base/batchCheckItemState', data, { appJson: true, submitType: 'json' })
}
/**
 * 批量更新平台商品资料
 * @param {*} data
 * @returns
 */
export const batchPlatformSkuEdit = (data) => {
  return post('/item/platform/batchEditItemV2', data, { appJson: true, submitType: 'json' })
}
/**
 * 删除不存在的链接
 * @param {*} data 参数
 * @returns
 */
export const batchClearExpirePublishInfo = (data) => {
  return post('/item/base/clearExpirePublishInfo', data, { appJson: true, submitType: 'json' })
}
/** 批量更新铺货 结束 */

// 同步商品分类
export const queryAutoSyncCategoryToKmt = (data = {}) => {
  return getAjax('/item/config/getAutoSyncCategoryToKmt', data)
}
// 一键生成平台资料
export const fastMergePlatformItem = (data = {}) => {
  return post('/publish/fast/merge/platform/item', data, { appJson: true, submitType: 'json' })
}
export const fastMergePlatformItemProgress = (data = {}) => {
  return get('/publish/fast/merge/platform/item/progress', data, { appJson: true, submitType: 'json',isNeedLoading: false })
}
// 平台商品详情
export const getFastDetail = (data = {}) => {
  return get('/publish/fast/detail', data)
}
export const updateAutoSyncCategoryToKmt = (data = {}) => {
  return postAjax('/item/config/updateAutoSyncCategoryToKmt', data)
}
export const loadItemConfig = (data = {}) => {
  return getAjax('/item/config/load', data)
}
/**
 * 缓存平台规格信息
 * @param {*} data 参数
 * @returns
 */
export const cachedPlatformSpecInfo = (data) => {
  return post('/item/base/editPlatformCacheInfo', data, { appJson: true, submitType: 'json' })
}
/**
 * 获取已缓存平台规格信息
 * @param {*} data
 * @returns
 */
export const getPlatformCachedSpecInfo = (data) => {
  return post('/item/base/queryPlatformCacheInfo', data, { appJson: true, submitType: 'json' })
}
/**
 * 删除已缓存平台规格信息
 * @param {*} data 
 */
export const deletePlatformCachedSpecInfo = (data) => {
  return post('/item/base/delPlatformCacheInfo', data, { appJson: true, submitType: 'json' })
}

/**
 * 类目/属性智能匹配
 * @param {*} data 参数
 * @returns
 */
// export const categoryAndPropertiesMatch = (data) => {
//   return post('/smartMatch/categoryAndPropertiesMatch', data, { appJson: true, submitType: 'json' })
// }
/** 类目/属性智能匹配  结束 */

export const judgeRemovePureItemWhitelist = data => {
  return get('/remove/pureItem/user/checkCompany', data).then(res => {
    return res.result === 1 ? res : Promise.reject(res);
  });
}

// 库存上传
const applicationJson = { appJson: true, submitType: 'json' };
// 0-平台资料 1-分销商品 2-平台链接 3-sku
const stockUploadApis = {
  0: '/item/stock/base/uploadStock',
  1: '/item/stock/distributor/uploadStock',
  2: '/item/stock/link/uploadStock',
  3: '/item/stock/sku/uploadStock',
};
export const reqUploadStock = (data, type = 0) => {
  return post(stockUploadApis[type], data, applicationJson).then(res => {
    return res;
  });
}
export const reqEditStockUploadType = (data) => {
  return post('/item/stock/base/editStockUploadType', data, applicationJson).then(res => {
    return res;
  });
}
// 复制平台资料
export const copyPlatformInfoApi = (data) => {
  return get('/item/base/copyItem', data)
}
/**
 * 获取从天猫后台快速导入尺码模板数据
 * shopId 天猫店铺ID
 */
export const GetTmImportTemplate = (data) => {
  return get('/tm/getItemDefaultSize', data).then(res => {
    return res;
  });
}

// 应用到其他店铺 一键应用到其他店铺
export const applyToOtherShop = (data) => {
  return get('/dsb/applyToOtherShop', data)
}
// 查询商品标签
export const getItemLabelApi = (data) => {
  return get('/itemLabel/list', data)
}
export const addItemLabelApi = (data) => {
  return post('/itemLabel/insert', data,applicationJson)
}
export const updateItemLableApi = (data) => {
  return post('/itemLabel/update', data,applicationJson)
}
export const deleteItemLabelApi = (data) => {
  return get('/itemLabel/delete', data)
}
export const isBindItemApi = (data) => {
  return get('/itemLabel/isBindItem', data)
}
export const itemLabelRelationApi = (data) => {
  return post('/itemLabel/relation', data,applicationJson)
}
/**
 * 获取美团接口详情
 * @param {*} data 
 * @returns 
 */
export const MtDetail = (data) => {
  return get('/yyjk/detail', data)
}

export const MtNoMedicineDetail = (data) => {
  return get('/fyy/detail', data)
}

export const getMtCelerityItemType = (data) => {
  return get('/fyy/getMtCelerityItemType', data)
}

// 美图医药健康编辑保存
export const editYyjkDetail = function (data) {
  const mtRapidType = localStorage.getItem('mtRapidType')
  const url = mtRapidType == 2?'/fyy/edit':'/yyjk/edit'
  console.log(url,data,'edit');
  return post(url, data, { appJson: true, submitType: 'json' });
}

/**
 * 获取店内分类下拉列表
 */

export const getRetailShopCats = (data) => {
  return get('/fyy/getRetailShopCats', data)
}

/**asd
 *  查询类目属性
 */

export const fyyCategoryProps = function(data) {
  return get('/fyy/getCategoryProperties', data, {isNeedLoading: true})
}
// 获取品牌、产地列表
export const fyyCategoryAttrValueList = function(data) {
  return get('/fyy/getCategoryAttrValueList', data, {isNeedLoading: true})
}
/**
 * 获取ai类目内容 
 * 
 * */
export const publishFastPrediction = (data, config) => {
  return post('/publish/fast/prediction/cat', data, config)
}
// 批量编辑退款地址
export const batchUpdateReceiveAddressApi = (data) => {
  return post('/item/base/batchUpdateReceiveAddress', data,applicationJson)
}
// 批量修正图片
export const batchResizeImages = (data) => {
  return post('/common/batch/resize/images', data,applicationJson)
}

// ==================== 铺货购物车相关接口 开始 ====================
/**
 * 添加商品到铺货购物车
 * @param {Object} params - { baseItemIds: number[] }
 * @returns {Promise}
 */
export const addToPublishCart = (params) => {
  return post('/item/piecePublish/cart/add', params, applicationJson)
}

/**
 * 获取购物车商品列表
 * @param {Object} params - { pageNo, pageSize }
 * @returns {Promise}
 */
export const getPublishCartList = (params) => {
  return get('/item/piecePublish/cart/get', params)
}

/**
 * 从购物车移除商品
 * @param {Object} params - { baseItemIds: number[] }
 * @returns {Promise}
 */
export const removeFromPublishCart = (params) => {
  return post('/item/piecePublish/cart/delete', params, applicationJson)
}

// ==================== 铺货购物车相关接口 结束 ====================
// 铺货之前校验供应商是否开通对应平台面单
export const queryUnopenedSuppliers = (params) => {
  return post('/item/platform/queryUnopenedSuppliers', params, applicationJson)
}

// ==================== 抖店商品诊断相关接口 开始 ====================

/**
 * 获取诊断商品汇总统计结果（长期低效品/高潜力新品）
 * @param {Object} data - { taskId }
 * @returns {Promise}
 */

export const getProductSuggestionResult = (data) => {
  return post('/fxg/getProductSuggestionResult', data, { isNeedLoading: false })
}

export const submitProductSuggestion = (data) => {
  return post('/fxg/submitProductSuggestion', data)
}

// 获取前端组件token
export const fxgOrderGetMCToken = (data) => {
  return get('/fxg/orderGetMCToken', data)
}
/**
 * 获取诊断商品列表（分页）
 * @param {Object} data - { shopId, pageNo, pageSize, suggestion: 'force_offline'|'suggest_offline'|'optimize' }
 * @returns {Promise}
 */
export const getProductSuggestionList = (data) => {
  return post('/fxg/getProductSuggestionList', data)
}

/**
 * 下架放心购商品（支持批量）
 * @param {Object} data - { shopId, productIds: 'id1,id2' }
 * @returns {Promise}
 */
export const offSaleItems = (data) => {
  return post('/fxg/offSaleItems', data, applicationJson)
}

/**
 * 一键下架全部 - 提交下架任务
 * @param {Object} data - { shopId }
 * @returns {Promise}
 */
export const submitOffSaleSuggestion = (data) => {
  return get('/fxg/submitOffSaleSuggestion', data)
}

/**
 * 一键下架全部 - 获取任务结果
 * @param {Object} data - { taskId }
 * @returns {Promise}
 */
export const getOffSaleSuggestionResult = (data) => {
  return get('/fxg/getOffSaleSuggestionResult', data)
}
// 获取放心购平台自动下架设置
export const queryFxgAutoOff = (data) => {
  return get('/dsb/queryFxgAutoOff', data)
}

// 保存放心购平台自动下架设置
export const saveFxgAutoOff = (data) => {
  return get('/dsb/saveFxgAutoOff', data)
}

// 查询抖音商品下架记录
export const queryItemOffShelvesRecord = (data) => {
  return post('/fxg/queryItemOffShelvesRecord', data, { appJson: true, submitType: 'json' })
}


/**
 * 查询商品质量分详情
 * @param {Object} data - { shopId, productId }
 * @returns {Promise}
 */
export const qualityDetail = (data) => {
  return post('/fxg/qualityDetail', data)
}

/**
 * AI托管中心 - 查询店铺托管及SEO信息（按店铺列表）
 * @param {Object} data - { shopId }
 * @returns {Promise}
 */
export const getShopHostingAndSeoInfo = (data) => {
  return get('/fxg/getShopHostingAndSeoInfo', data)
}

/**
 * AI托管中心 - 开启/关闭生图托管状态
 * @param {Object} data - { shopId, materialHostingVos: [{ open, sceneType }] }
 * sceneType: 1=34图, 2=主图视频, 3=11图
 * @returns {Promise}
 */
export const updateMaterialHostingSwitch = (data) => {
  return post('/fxg/updateMaterialHostingSwitch', data, { appJson: true, submitType: 'json' })
}

/**
 * AI托管中心 - 查询店铺托管信息
 * @param {Object} data - { shopId, sceneType }
 * @returns {Promise}
 */
export const getShopHostingInfo = (data) => {
  return post('/fxg/getShopHostingInfo', data)
}

// ==================== 抖店商品诊断相关接口 结束 ====================
